import ProviderIcon from './ProviderIcon.vue'

export default ProviderIcon;
